import React, { useEffect, useState } from "react";
import instance from "../../helpers/api.instance";
import { notification } from "../../helpers/Helpers";
import { PERFILES_MPSP_JEFES } from "../../helpers/mpsp";
import "./Mpsp.css";

const pct = (v) => (v === null || v === undefined ? "—" : `${Number(v).toFixed(2)}%`);
// resultado - puntos alcanzados (logro topado * peso)
const pctPuntos = (resultado, logro) => `${pct(resultado)} - ${pct(logro)}`;
const mxn = (v) =>
  Number(v).toLocaleString("es-MX", { style: "currency", currency: "MXN" });

const mesActual = () => {
  const hoy = new Date();
  return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}`;
};

const MpspTabla = ({ esJefes, filas }) => (
  <div className="table-responsive">
    <table
      className={`table mpsp-tabla ${esJefes ? "mpsp-tabla-rosa" : "mpsp-tabla-azul"}`}
    >
      <thead>
        {esJefes ? (
          <tr>
            <th>TDA</th>
            <th>Almacén</th>
            <th>Núm. empleado</th>
            <th>Nombre</th>
            <th>Puesto</th>
            <th>% Aceptación TDC (85%)<br />Peso 25%</th>
            <th>% Aceptación Piso (15%)<br />Peso 15%</th>
            <th>Reactivaciones (100%)<br />Peso 30%</th>
            <th>Cancelación M1 (15%)<br />Peso 20%</th>
            <th>Migración (100%)<br />Peso 5%</th>
            <th>Mix (25%*)<br />Peso 5%</th>
            <th>MPSP total</th>
            <th>Monto estimado del mes 1</th>
          </tr>
        ) : (
          <tr>
            <th>TDA</th>
            <th>Almacén</th>
            <th>Núm. empleado</th>
            <th>Nombre</th>
            <th>Puesto</th>
            <th>% Aceptación (85%)<br />Peso 35%</th>
            <th>Reactivaciones (100%)<br />Peso 35%</th>
            <th>Cancelación M1 (15%)<br />Peso 20%</th>
            <th>Migración (100%)<br />Peso 5%</th>
            <th>Mix (25%*)<br />Peso 5%</th>
            <th>MPSP total</th>
            <th>Monto estimado del mes 1</th>
          </tr>
        )}
      </thead>
      <tbody>
        {filas.length === 0 && (
          <tr>
            <td colSpan={esJefes ? 13 : 12} className="text-center">
              Sin información
            </td>
          </tr>
        )}
        {filas.map((f) => (
          <tr key={f.numeroEmpleado}>
            <td>{f.numeroTienda}</td>
            <td>{f.nombreTienda}</td>
            <td>{f.numeroEmpleado}</td>
            <td>{f.nombre}</td>
            <td>{f.puesto}</td>
            {esJefes ? (
              <>
                <td>{pctPuntos(f.aceptacionTdc, f.puntos.aceptacion)}</td>
                <td>{pctPuntos(f.aceptacionPiso, f.puntos.aceptacionPiso)}</td>
              </>
            ) : (
              <td>{pctPuntos(f.aceptacion, f.puntos.aceptacion)}</td>
            )}
            <td>{pctPuntos(f.reactivaciones, f.puntos.reactivaciones)}</td>
            <td>{pctPuntos(f.cancelacionM1, f.puntos.cancelacionM1)}</td>
            <td>{pctPuntos(f.migracion, f.puntos.migracion)}</td>
            <td>{pctPuntos(f.mix, f.puntos.mix)}</td>
            <td className="mpsp-total">{Number(f.mpspTotal).toFixed(2)}%</td>
            <td className="mpsp-total">{mxn(f.montoPagar)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const Mpsp = ({ userInfo, setloading }) => {
  const [fecha, setfecha] = useState(mesActual());
  const [tipo, settipo] = useState(
    PERFILES_MPSP_JEFES.includes(userInfo.clavePerfil) ? "jefes" : "asesores"
  );
  const [filas, setfilas] = useState([]);
  const [jefesSupervisores, setjefesSupervisores] = useState([]);
  const [asesores, setasesores] = useState([]);

  useEffect(() => {
    if (!fecha) return;
    const [anioCarga, mesCarga] = fecha.split("-");
    setloading(true);
    instance
      .post("/mpsp/colaboradores", { mesCarga, anioCarga })
      .then((res) => {
        if (res.status === 1) {
          if (res.tipo) settipo(res.tipo);
          setfilas(res.data || []);
          setjefesSupervisores(res.jefesSupervisores || []);
          setasesores(res.asesores || []);
        } else {
          setfilas([]);
          setjefesSupervisores([]);
          setasesores([]);
        }
      })
      .catch(() => notification("No se pudo consultar el MPSP.", "error"))
      .finally(() => setloading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fecha]);

  const esJefes = tipo === "jefes";

  return (
    <div className="card rounded p-3 mpsp">
      <div className="d-flex justify-content-end align-items-center mb-3">
        <label htmlFor="mpspFecha" className="mr-2 mb-0">
          Periodo:
        </label>
        <input
          type="month"
          id="mpspFecha"
          className="form-control w-auto"
          value={fecha}
          onChange={(e) => setfecha(e.target.value)}
        />
      </div>

      <h4 className={`mpsp-titulo ${esJefes ? "mpsp-rosa" : "mpsp-azul"}`}>
        {esJefes
          ? "MPSP POR COLABORADOR – JEFES / SUPERVISORES (LIVERPOOL)"
          : "MPSP POR COLABORADOR – ASESORES (LIVERPOOL)"}
      </h4>

      <small className="text-muted d-block mb-2">
        Cada indicador se muestra como: resultado - puntos alcanzados.
      </small>

      <MpspTabla esJefes={esJefes} filas={[...filas, ...jefesSupervisores]} />

      {esJefes && asesores.length > 0 && (
        <>
          <h4 className="mpsp-titulo mpsp-azul mt-4">
            MPSP POR COLABORADOR – ASESORES (LIVERPOOL)
          </h4>
          <MpspTabla esJefes={false} filas={asesores} />
        </>
      )}
    </div>
  );
};

export default Mpsp;
